import { useContext, useEffect, useState } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { Helmet } from "react-helmet-async";

const Careers = () => {
  const [careers, setCareers] = useState([]);
  const { setActiveRoute, setActiveSection } = useContext(AppContext);

  useEffect(() => {
    setActiveRoute("/careers");
    setActiveSection("");
  }, [setActiveRoute, setActiveSection]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(
          "https://script.google.com/macros/s/AKfycbzbV9gKjyr9uMJUPSMS5FIHlKEp9ETWr3EP1bdvnSSG1RQY5A2-bPeOdAWx7Ez5qYEP2A/exec",
          {
            method: "GET",
            mode: "cors", // ✅ use "cors", NOT "no cors"
          },
        );
        const data = await res.json();
        setCareers(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchDetails();
  }, [setActiveRoute]);

  return (
    <>
      <Helmet>
        <title>
          Careers at IBIX Qodify | Join Our Software Training & Tech Team
        </title>
        <meta
          name="description"
          content="Explore exciting career opportunities at IBIX Qodify. We're hiring for roles in sales, development, marketing, training, and internships. Build your future with us in Hyderabad."
        />
      </Helmet>
      <section className="careers-page">
        <img
          src="https://iqteche.in/static/media/wl_client_images/41991d480c504ca8ba321c9f982ceb70.png"
          alt="careers"
          className="w-100 mb-5"
        />
        <div className="container">
          {careers.length === 0 && <p className="text-center">Loading...</p>}
          <div className="row">
            {careers.map((job, index) => {
              // console.log("FULL JOB:", job);
              // console.log("FEATURED:", job.featured);

              return (
                <div
                  key={job.job_id || job.id || index} // ✅ key should be on this element
                  className="col-12 col-md-6 col-lg-4"
                >
                  <div className="col-12 mb-4">
                    <div
                      className={`job-card ${
                        job.description?.toLowerCase() === "open"
                          ? "featured-job"
                          : ""
                      }`}
                    >
                      <div className="job-basic">
                        <h5>{job.title}</h5>
                        <p>{job.description}</p>

                        <div className="job-meta">
                          <span>{job.location}</span>
                        </div>

                        <Link
                          to={`/careers/${job.title
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, "-")}/${job.job_id}`}
                          className="btn btn-outline-primary btn-sm mt-2"
                        >
                          View & Apply
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
